module.exports = __webpack_public_path__ + "img/24.526ce341.png";